import { Injectable, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SpaContext } from '../../Classes/spacontext';
import { environment } from 'Public_old/src/environments/environment';
import { DropInQueueInterface } from './dropin-queue-interface.class';
import { DropInQueueWebSocket } from './dropin-queue-websocket.class';
import { DropInQueueQueue } from './dropin-queue-queue.class';

import { GeneralService } from '../general.service';
import { DropInUnitServiceV2 } from '../api/v2/Units/dropIn.service';
import { SpaEventService } from '../spaEvents.service';
import { DropInTicketApiModel } from '../api/v2/Models/DropInTicketApiModel';
import { DropInServiceV2 } from '../api/v2/dropin.service';
import { SpaLogger } from 'Public_old/src/app/Common/Classes/Global/spalogger.class';
import { AudioPlayerService } from 'Public_old/src/app/Common/Services/audioPlayer.service';
import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { Helper } from 'Public_old/src/app/Common/Helpers/helper';
import { VisibaPopup } from 'Public_old/src/app/Common/Classes/visibaPopup';
import { DropInModule } from 'Public_old/src/app/Views/DropIn/dropin-room.class';
import { AuthContextService } from '../authContext.service';
import { DateService } from '../date.service';

@Injectable()
export class DropInQueueService {
	IH: DropInQueueInterface;
	webSocket: DropInQueueWebSocket = null;
	queue: DropInQueueQueue = null;
	room: DropInModule.Room = null;
	ticketInfo: any = null;
	event: EventEmitter<DropInQueueService.EventPackage> = new EventEmitter<DropInQueueService.EventPackage>();
	isAlive: boolean = false;
	isInited: boolean = false;

	currentUrlAlias: string = null;
	currentTicket: string = null;
	lastFetchedActiveTicket: DropInTicketApiModel = null;
	connectionError = false;

	constructor(
		private spaLogger: SpaLogger,
		private _spaEventService: SpaEventService,
		public generalService: GeneralService,
		public audioPlayerService: AudioPlayerService,
		public _dropInService: DropInServiceV2,
		public _dropInUnitService: DropInUnitServiceV2,
		public _router: Router,
		public _activatedRoute: ActivatedRoute,
		public _spaContext: SpaContext,
		private translateService: TranslateService,
		private authContextService: AuthContextService,
		private helper: Helper,
		private dateService: DateService,
	) {
		let routeSub = this._router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				if (this._router.url.indexOf('multiconnections') > -1) return;

				routeSub.unsubscribe();
				this.tryGetTicket();
			}
		});

		this._spaEventService.onSignedIn.subscribe(() => {
			this.tryGetTicket();
		});
		this._spaEventService.onCallEnded.subscribe(() => {
			this.tryGetTicket();
		});
	}

	public tryGetTicket() {
		if (this.authContextService.isPatient()) {
			this._dropInService.getActiveTicket().subscribe(
				(response) => {
					this.lastFetchedActiveTicket = response.data;
					this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.OnGetActiveTicket, response.data));
					if (response.sucessful && response.data !== null) {
						if (!this.isInited) {
							if (response.data.Payment !== null) {
								const dropInLink = '/dropin/' + response.data.DropInRoomUrlAlias + '/' + response.data.Ticket;
								if (response.data.UnitId !== this._spaContext.unitConfig.Unit.UnitId) {
									window.location.href =
										this.helper.unit.getUnitUrl(response.data.UnitId, this._spaContext.unitTreeFlat) + dropInLink;
								} else {
									this._router.navigate([dropInLink]);
								}
							} else {
								this.init(
									this._spaContext.unitConfig.LicenceHolder.Id,
									response.data.DropInRoomUrlAlias,
									response.data.Ticket,
									response.data.UnitId,
								);
							}
						}
					}
				},
				(error) => {},
			);
		}
	}

	init(licenceHolderId: number, urlAlias: string, ticket: any, unitId: number = null) {
		if (this.isAlive) {
			this.destroy();
		}

		if (this.isInited) return;

		this.currentUrlAlias = urlAlias;
		this.currentTicket = ticket;
		this.isInited = true;

		this._dropInUnitService.getByUrlAlias(urlAlias, unitId).subscribe(
			(response) => {
				this.room = new DropInModule.Room(response.data, this.translateService, this._spaContext, this.dateService);

				this.IH = new DropInQueueInterface(this, this.translateService);
				this.webSocket = new DropInQueueWebSocket(
					this._router,
					this.spaLogger,
					this,
					this.audioPlayerService,
					ticket,
					this._spaContext,
					this.translateService,
					this.helper,
				);
				this.queue = new DropInQueueQueue(this.spaLogger, this.generalService, this, this.translateService, this.helper);
				this.isAlive = true;

				this.queue.onDataEvent.subscribe((data) => {
					this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.QueueInfoUpdated));
				});

				this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.FetchCompleted));
			},
			(error) => {
				this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.FetchFail));
			},
		);
		this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.Initialize));
	}

	destroy() {
		if (this.queue) this.queue.destroy();
		if (this.webSocket !== null && typeof this.webSocket.conn !== 'undefined' && this.webSocket.conn !== null) {
			this.webSocket.conn.onClose = () => {};
			this.webSocket.conn.close();
		}
		this.IH.stopQueueCountdownTimer();
		this.isAlive = false;
		this.isInited = false;
		this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.Destroyed));
	}

	leaveQueue(doDefaultRouting: boolean = true) {
		this.webSocket.ws.invoke('CancelMyTicket', JSON.stringify({ ticket: this.ticketInfo.Ticket })).then(() => {
			if (doDefaultRouting) {
				if (this.ticketInfo.CompletedRedirectUrl !== null && this.ticketInfo.CompletedRedirectUrl !== '') {
					window.location.href = this.ticketInfo.CompletedRedirectUrl;
				}
			}
			this.destroy();
		});
	}

	onKickedFromQueue() {
		this.destroy();
		this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.KickedFromQueue));
		new VisibaPopup(
			this.translateService.get('LicenceHolder.DropInQueue.Title.KickedFromQueue') as string,
			this.translateService.get('LicenceHolder.DropInQueue.Phrase.KickedFromQueue') as string,
		)
			.inform(this.translateService.get('Common.Button.OK') as string)
			.attatch()
			.observer()
			.subscribe((ok) => {});
	}

	onAppError() {
		this.connectionError = true;
	}

	onAcceptHandshake() {
		this.event.emit(new DropInQueueService.EventPackage(DropInQueueService.EventType.AcceptHandShake));
		this.audioPlayerService.stop(`${environment.serverBaseUrl}/assets/Ring1.mp3`);
	}
}

export module DropInQueueService {
	export class EventPackage {
		constructor(public eventType: EventType, public data: any = null) {}
	}
	export enum EventType {
		FetchFail,
		FetchCompleted,
		KickedFromQueue,
		AcceptHandShake,
		Destroyed,
		Initialize,
		OnGetActiveTicket,
		QueueInfoUpdated,
	}
}
